import React, { useContext } from 'react'
import NavbarCommon from '../components/NavbarCommon';
import Footer from '../components/Footer';
import { Button, Card, CardBody, CardHeader, Typography } from '@material-tailwind/react';
import { BookmarkIcon, BriefcaseIcon, MapPinIcon } from '@heroicons/react/24/solid';
import CallToAction from '../components/CallToAction';
import { DataContext } from '../context/DataProvider';
import { useParams } from 'react-router-dom';

function DetailLowonganKerja() {
  const { data, loading } = useContext(DataContext)
  const { jobId } = useParams()

  // Find the job with specified Id
  const selectedJob = data.data.find((job) => job.id === parseInt(jobId, 10))

  if (!selectedJob) {
    return <p>Job not found</p>;
  }

  // Check if data is undefined before mapping
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <NavbarCommon />
      {/* 
    GET https://dev-example.sanbercloud.com/api/job-vacancy

    == detail parameter data lowongan pekerjaan ==  
    title : string, Contoh value -> FrontendDeveloper
    job_description : string, Contoh value ->  Melakukan implementasi tampilan web dll
    job_qualification : string, Contoh value -> Harus bisa React dll
    job_type : string, Contoh value -> onSite/work from home/hybird
    job_tenure : string, Contoh value -> kontrak, magang dll
    job_status : integer,  Contoh value -> 0 dan 1. 0 untuk Ditutup, 1 untuk Dibuka
    company_name : string, Contoh value -> Google
    company_image_url : string, Contoh value -> Bisa cari di google atau www.istockphoto.com dengan keyword company logo, klik kanan pada gambar lalu copy image address
    company_city : string, Contoh value -> Jakarta
    salary_min : integer, Contoh value -> 9000000
    salary_max : integer, Contoh value -> 10000000 
    */}

      <div className='px-7 md:px-11 pt-5 pb-10 space-y-6 md:grid grid-cols-2 grid-rows-3 gap-4'>
        {/* informasi umum */}
        <Card className='col-span-2 w-full flex flex-col md:flex-row items-start'>
          <CardHeader
            color="transparent"
            floated={false}
            shadow={false}
            className="flex items-center gap-4"
          >
            <img src={selectedJob.company_image_url} alt='apa ya?' className='w-52'/>
          </CardHeader>
          <CardBody className="space-y-6">

            <div className="mb-4">
              <div className="flex flex-col md:flex-row justify-start gap-2">
                <Typography color="blue-gray" className="text-2xl md:text-xl font-semibold">{selectedJob.title}</Typography>
                <Typography color="blue-gray" className="text-2xl md:text-xl font-thin">{selectedJob.company_name}</Typography>
              </div>
            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3'>
              <div className="flex ">
                <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
                <Typography variant="leads">{selectedJob.company_city}</Typography>
              </div>
              <div className="flex ">
                <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
                <Typography variant="leads">{selectedJob.job_type}</Typography>
              </div>
              <div className="flex ">
                <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
                <Typography variant="leads">{selectedJob.job_tenure}</Typography>
              </div>
            </div>

            <div className='flex flex-col md:flex-row gap-3'>
              <Button size="md" className='flex items-center gap-1'> <BriefcaseIcon className='w-3 text-gray-200 dark:text-gray-200' />Apply For This Job</Button>
              <Button size="md" className='flex items-center gap-1'> <BookmarkIcon className='w-3 text-gray-200 dark:text-gray-200' />Add to Bookmark</Button>
            </div>
          </CardBody>
        </Card>
        {/* deskripsi */}
        <Card className='row-span-2 row-start-2 w-full flex flex-col md:flex-row items-start'>
          <CardBody className="space-y-6">
            <div>
              <Typography className="text-lg font-bold">Deskripsi</Typography>
              <Typography className="text-sm">{selectedJob.job_description}</Typography>
            </div>
            <div>
              <Typography className="text-lg font-bold">Kualifikasi</Typography>
              <Typography className="text-sm">{selectedJob.job_qualification}</Typography>
            </div>
          </CardBody>
        </Card>
        {/* Short Info */}
        <Card className='row-start-2 w-full flex flex-col md:flex-row items-start'>
          <CardBody className="space-y-2">
            
            <Typography className="text-lg font-bold">Info Lainnya</Typography>
            <div className="flex ">
              <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
              <Typography variant="leads">Status : {selectedJob.job_status}</Typography>
            </div>
            <div className="flex ">
              <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
              <Typography variant="leads">Salary : {selectedJob.salary_min}-{selectedJob.salary_max}</Typography>
            </div>
            <div className="flex ">
              <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
              <Typography variant="leads">Tanggal Posting : {selectedJob.created_at}</Typography>
            </div>
          </CardBody>
        </Card>
        {/* Company info */}
        <Card className='col-start-2 row-start-3 w-full flex flex-col md:flex-row items-start'>
        <CardBody className="space-y-2">
            <Typography className="text-lg font-bold">Company Informasi</Typography>
            <div className="flex ">
              <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
              <Typography variant="leads">Company name : {selectedJob.company_name}</Typography>
            </div>
            <div className="flex ">
              <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200" />
              <Typography variant="leads">Address : {selectedJob.company_city}</Typography>
            </div>
          </CardBody>
        </Card>
      </div>

      <CallToAction></CallToAction>

      <Footer />
    </>
  )
}

export default DetailLowonganKerja;